import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import {
    DKLabel,
    DKButton,
    DKInput,
    DKCheckMark,
    DKTooltipWrapper,
    DKIcon,
    DKIcons,
    DKSpinner,
    Toggle,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION,
    showLoader,
    removeLoader,
    showToast,
    TOAST_TYPE,
    showAlert
} from "deskera-ui-library";
import TimesheetService from "../TimesheetService";
import TimesheetUtils from "../TimesheetUtils";
import Utility, { getCapitalized } from "../../../utility/Utility";
import { convertCamelCaseToWord } from "../../../managers/common/CommonUtil";
import ic_folder_2 from "../../../assets/icons/ic_folder_2.svg";
import { DATE_FORMAT } from "../../../constants/Constant";
import moment from "moment";

function ViewTimesheetEntry(props) {
    const { t } = useTranslation();

    useEffect(() => {
        // return removeElement;
    }, []);

    const removeElement = () => {
        if (props.elementId) {
            const element = document.getElementById(props.elementId);
            if (element) {
                ReactDOM.unmountComponentAtNode(element);
                element.remove();
            }
        }
    }

    const getEntryClass = (status) => {
        return `entry-div entry-status p-h-s p-v-xs border-radius-l ml-m ${status === "_" || !status ? "draft" : String(status).toLowerCase()}`;
    }

    const getEntryStatus = (status) => {
        return status === "_" || !status ? "Draft" : getCapitalized(String(status).toLowerCase());
    }

    const renderHeaderAndValue = (icon, header, value) => {
        return (
            <div className="d-flex mt-m">
                <DKIcon src={icon} className="ic-s-2" />
                <div className="ml-m">
                    <DKLabel text={header} className="text-gray" />
                    <DKLabel text={value} className="" />
                </div>
            </div>
        );
    }

    return (
        <div className="transparent-background">
            <div className="popup-window" style={{ padding: 0, width: "250px", overflow: "hidden" }}>
                <div className="parent-width">
                    <div className="p-l">
                        <div className="row">
                            <div style={{ maxWidth: "calc(100% - 115px)" }}>
                                <DKLabel text={props?.entry.jobName} className="fs-m fw-b ellipsis" />
                            </div>
                            <div className={getEntryClass(props?.entry.status)}>
                                {getEntryStatus(props?.entry.status)}
                            </div>
                            <div className="ml-auto d-flex">
                                <DKButton
                                    icon={DKIcons.ic_close}
                                    style={{ padding: 0 }}
                                    onClick={() => {
                                        removeElement();
                                    }}
                                />
                            </div>
                        </div>
                        {renderHeaderAndValue(ic_folder_2, "Project", props?.entry.projectName)}
                        {renderHeaderAndValue(DKIcons.ic_user_2, "Customer", props?.entry.customerName)}
                        {renderHeaderAndValue(DKIcons.ic_calendar, "Entry Date", Utility.formatDate(props?.entry.fromDate, DATE_FORMAT.YYYYMMDD))}
                        {renderHeaderAndValue(DKIcons.ic_calendar, "From", moment(props?.entry.fromDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("hh:mm A"))}
                        {renderHeaderAndValue(DKIcons.ic_calendar, "To", props?.entry.toDate?moment(props?.entry.toDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("hh:mm A"):"-")}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewTimesheetEntry;
